import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requirePrettierBytes } from "../node_modules/.pnpm/@transloadit_prettier-bytes@0.3.5/node_modules/@transloadit/prettier-bytes/dist/prettierBytes.js";
var prettierBytesExports = requirePrettierBytes();
const prettierBytes = /* @__PURE__ */ getDefaultExportFromCjs(prettierBytesExports);
export {
  prettierBytes as default
};
//# sourceMappingURL=prettierBytes.js.map
